import { AppLayout } from 'layouts';
import { JoinedOrganizations } from 'features/organizations';
import { useGetPathToEntityDetail } from 'pages/hooks';

const PageJoinedOrganizations = () => {
  const getPathToEntityDetail = useGetPathToEntityDetail();

  return (
    <AppLayout>
      <JoinedOrganizations
        getPathToOrganizationDetail={(id) => getPathToEntityDetail(id, { entityType: 'organization' })}
      />
    </AppLayout>
  );
};

export default PageJoinedOrganizations;
